import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import EmployeeContext from '@/product/context/employee/empContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import AuthContext from '@/product/context/auth/authContext'
import { mapData, handleRedirectInternal } from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { LinearProgress } from '@mui/material'
import Loaders from '@/product/components/molecules/Loaders'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router'

const EmployeeManage = (props) => {
    const isFullScreen = props?.data ? true : false
    const employeeContext = useContext(EmployeeContext)
    const authContext = useContext(AuthContext)
    const { allCountries, allStates } = useContext(ProductCommonContext)

    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const history = useHistory()
    const { user, loadUser } = authContext
    const {
        single_employee,
        getSingleEmployee,
        employeeAction,
        responseStatus: responseStatusEmployee,
    } = employeeContext
    const permission = [
        {
            id: '/dashboard',
            description: 'Dashboard',
        },

        {
            id: '/agency/all',
            description: 'Agency Profile',
        },
        // {
        //     id: '/agency/disposal',
        //     description: 'Disposal Requests',
        // },
        // {
        //     id: '/agency/tracking',
        //     description: 'Tracking Report',
        // },
        {
            id: '/agency/payment',
            description: 'Payment Received',
        },
        {
            id: '/listing/all',
            description: 'Open Listing',
        },

        {
            id: '/listing/open',
            description: 'Open Listing',
        },
        {
            id: '/listing/sold',
            description: 'Sold Listing',
        },
        {
            id: '/listing/unsold',
            description: 'Unsold Listing',
        },
        {
            id: '/listing/draft',
            description: 'Draft Listing',
        },
        {
            id: '/listing/relisted',
            description: 'Relisted Listing',
        },
        {
            id: '/questions_answers',
            description: 'Questions & Answers',
        },
        {
            id: '/invoice/all',
            description: 'All Invoices',
        },
        {
            id: '/invoice/draft',
            description: 'Invoice Partial',
        },
        {
            id: '/invoice/paid',
            description: 'Invoice Paid',
        },
        {
            id: '/invoice/unpaid',
            description: 'Invoice Unpaid',
        },
        {
            id: '/invoice/cancel',
            description: 'Invoice Archive',
        },
        {
            id: '/invoice/paid/completed',
            description: 'Invoice Paid Completed',
        },
        {
            id: '/invoice/paid/not_completed',
            description: 'Invoice Paid Not Completed',
        },
        {
            id: '/invoice/payment/received',
            description: 'Transactions Payment Received',
        },
        {
            id: '/invoice/payment/not_received',
            description: 'Transactions Payment Not Received',
        },
    ]
    const [permissionSelect, setPermissionSelect] = useState(permission)
    const data = props.data
    const toggleFullScreenPopup = props.function

    const validationArray = Yup.object({
        emp_email: Yup.string()
            .email('Invalid email format')
            .required('Required!'),
        confirm_email:
            props?.match?.params?.status === 'new'
                ? Yup.string()
                      .email('Invalid email format')
                      .oneOf([Yup.ref('emp_email')], "Email's not match")
                      .required('Required!')
                : Yup.string(),
        emp_firstname: Yup.string()
            .min(2, 'Mininum 2 characters')
            .max(15, 'Maximum 15 characters')
            .required('Required!'),
        emp_lastname: Yup.string()
            .min(2, 'Mininum 2 characters')
            .max(15, 'Maximum 15 characters')
            .required('Required!'),
        emp_address1: Yup.string().required('Required!'),
        emp_phone: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .min(15, 'Please enter correct phone number')
            .required('Required!'),
        emp_type: Yup.string().required('Required!'),
        user_level: Yup.string().required('Required!'),
        emp_city: Yup.string()
            .trim()
            .matches(/^[0-9a-zA-Z ]*$/g, 'The characters only')
            .required('Required'),
        emp_state: Yup.string().required('Required!'),
        emp_country: Yup.string().required('Required!'),
        emp_zip: Yup.string()
            .trim()
            .matches(/^[0-9]*$/g, 'The positive number only')
            .min(5, 'Maximum 5 characters')
            .max(6, 'Maximum 6 characters')
            .required('Required'),
        emp_permissions: Yup.array().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            emp_email: '',
            confirm_email: '',
            password: '',
            confirm_password: '',
            emp_firstname: '',
            emp_lastname: '',
            emp_address1: '',
            emp_type: 'agency',
            emp_phone: '',
            user_level: 'user',
            emp_city: '',
            emp_state: global.defaultState,
            emp_country: global.defaultCountry,
            emp_zip: '',
            emp_permissions: [],
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            let value = values
            if (value.id === 0 && props?.custom && props?.agencyData?.id > 0) {
                value.emp_agencies = props?.agencyData?.id?.toString()
            } else if (props?.match?.params?.aid && value.id === 0) {
                value.emp_agencies = props?.match?.params?.aid
            }
            employeeAction(value)
            setIsLoading(true)
        },
    })

    useEffect(() => {
        if (responseStatusEmployee) {
            if (responseStatusEmployee.status === 'success') {
                if (responseStatusEmployee.from === 'employeeAction') {
                    formik.resetForm()
                    formikPassword.resetForm()
                    if (props?.match?.params?.aid) {
                        handleRedirectInternal(
                            history,
                            `agency/edit/${props?.match?.params?.aid}`
                        )
                    } else {
                        history.goBack()
                    }
                    loadUser()
                }
            }
            formik.setSubmitting(false)
            setIsLoading(false)
        }
    }, [responseStatusEmployee])

    // useEffect(() => {
    //     resetFrom()
    // }, [props])

    useEffect(() => {
        if (
            props?.match?.params?.id &&
            props?.match?.params?.status == 'edit'
        ) {
            setIsLoading(true)
            formik.values.id = props?.match?.params?.id
                ? parseInt(props?.match?.params?.id)
                : 0
            formikPassword.values.id = props?.match?.params?.id
                ? parseInt(props?.match?.params?.id)
                : 0
            getSingleEmployee(formik.values)
        } else {
            resetFrom()
            setIsLoading(false)
        }
    }, [props?.match?.params?.id])

    useEffect(() => {
        if (
            single_employee.record &&
            props?.match?.params?.id &&
            props?.match?.params?.status == 'edit'
        ) {
            const user = single_employee.record
            formik.values.emp_email = user.emp_email
            formik.values.emp_address1 = user.emp_address1
            formik.values.emp_phone = user.emp_phone
            formik.values.emp_city = user.emp_city
            formik.values.emp_firstname = user.emp_firstname
            formik.values.emp_lastname = user.emp_lastname
            formik.values.emp_type = user.emp_type
            formik.values.user_level = user?.user_level || ''
            formik.values.emp_state = user.emp_state
                ? user.emp_state
                : global.defaultState
            formik.values.emp_country = user.emp_country
                ? user.emp_country
                : global.defaultCountry
            formik.values.emp_zip = user.emp_zip
            formik.values.emp_permissions =
                user?.emp_permissions && user.emp_permissions.length
                    ? user.emp_permissions.split(',')
                    : []
            setReload(!reload)
        } else {
            resetFrom()
        }
        setIsLoading(false)
    }, [single_employee])

    console.log(single_employee, 'single_employee')

    const levelOptions = []
    if (user?.emp_type !== 'agency') {
        levelOptions.push(
            { value: 'administrator', show: 'Admin' },
            { value: 'manager', show: 'Manager' },
            { value: 'user', show: 'User' }
        )
    } else if (user?.user_level === 'administrator') {
        levelOptions.push(
            { value: 'manager', show: 'Manager' },
            { value: 'user', show: 'User' }
        )
    } else if (user?.user_level === 'manager') {
        levelOptions.push({ value: 'user', show: 'User' })
    }

    const resetFrom = () => {
        formik.values.id = 0
        formik.values.emp_email = ''
        formik.values.emp_address1 = ''
        formik.values.emp_phone = ''
        formik.values.emp_city = ''
        formik.values.emp_firstname = ''
        formik.values.emp_lastname = ''
        formik.values.emp_type = 'agency'
        formik.values.user_level = 'user'
        formik.values.emp_state = global.defaultState
        formik.values.emp_country = global.defaultCountry
        formik.values.emp_zip = ''
        formik.values.emp_permissions = []
        formik.handleReset()
        setIsLoading(false)
    }

    const personalDetailsNew = {
        formik: formik,
        data: [
            {
                label: 'First name *',
                type: 'text',
                placeholder: 'Enter your first name',
                class: 'col-sm-6 col-12',
                name: 'emp_firstname',
                autoFocus: true,
            },
            {
                label: 'Last Name *',
                placeholder: 'Enter last name',
                type: 'text',
                class: 'col-sm-6 col-12',
                name: 'emp_lastname',
            },
            {
                label: 'Phone Number *',
                placeholder: 'Enter phone number',
                type: 'phone',
                class: 'col-sm-6 col-12',
                name: 'emp_phone',
                countryCodeEditable: false,
            },
            {
                label: 'User Level *',
                placeholder: 'Select user level',
                class: 'col-sm-6 col-12',
                type: 'select',
                options: levelOptions,
                name: 'user_level',
            },
        ],
    }
    if (props?.match?.params?.status == 'new') {
        personalDetailsNew.data.push(
            {
                label: 'Email Address *',
                placeholder: 'Enter email address',
                type: 'text',
                class: 'col-sm-6 col-12',
                name: 'emp_email',
            },
            {
                label: 'Confirm Email Address',
                placeholder: 'Confirm your email address',
                type: 'text',
                class: 'col-sm-6 col-12',
                name: 'confirm_email',
            }
        )
    } else {
        personalDetailsNew.data.push({
            label: 'Email Address',
            placeholder: 'Enter email address',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_email',
            disabled: user?.emp_type == 'agency' ? true : false,
        })
    }
    const locationDetails = {
        formik: formik,
        data: [
            {
                label: 'Street Address *',
                placeholder: 'Enter street address',
                type: 'text',
                class: 'col-sm-6 col-12',
                name: 'emp_address1',
            },
            {
                label: 'Country *',
                placeholder: 'Select country',
                class: `col-sm-6 col-12`,
                type: 'select',
                disabled: true,
                options: allCountries
                    .filter(
                        (country) =>
                            global.ignoreCountry.indexOf(country.isoCode) === -1
                    )
                    .map((country) => {
                        let busCategoryChanged = {}
                        busCategoryChanged.show = country.name
                        busCategoryChanged.value = country.isoCode
                        return busCategoryChanged
                    }),
                name: 'emp_country',
            },
            {
                label: 'State *',
                placeholder: 'Select state',
                class: `col-sm-6 col-12`,
                type: 'select',
                disabled: true,
                options: allStates
                    .filter(
                        (state) =>
                            (formik.values.emp_country
                                ? formik.values.emp_country.indexOf(
                                      state.countryCode
                                  ) !== -1
                                : global.defaultCountry.indexOf(
                                      state.countryCode
                                  ) !== -1) &&
                            global.ignoreStates.indexOf(state.isoCode) === -1
                    )
                    .map((buscat) => {
                        let busCategoryChanged = {}
                        busCategoryChanged.show = buscat.name
                        busCategoryChanged.value = buscat.isoCode
                        return busCategoryChanged
                    }),
                name: 'emp_state',
            },
            {
                label: 'City *',
                placeholder: 'Enter city',
                type: 'text',
                class: 'col-sm-6 col-12',
                name: 'emp_city',
            },
            {
                label: 'ZIP *',
                placeholder: 'Enter ZIP',
                type: 'number',
                class: 'col-sm-6 col-12',
                name: 'emp_zip',
            },
        ],
    }

    useEffect(() => {
        if (props?.match?.params?.status === 'new') {
            if (formik.values.user_level === 'administrator') {
                formik.values.emp_permissions = [
                    '/agency/disposal',
                    '/agency/all',
                    '/dashboard',
                    '/agency/payment',
                    '/listing/all',
                    '/listing/open',
                    '/listing/sold',
                    '/invoice/all',
                    '/invoice/payment/received',
                    '/invoice/payment/not_received',
                    '/invoice/draft',
                    '/listing/unsold',
                    '/listing/draft',
                    '/invoice/paid',
                    '/invoice/paid/completed',
                    '/invoice/paid/not_completed',
                    '/invoice/unpaid',
                    '/listing/relisted',
                    '/questions_answers',
                    '/invoice/cancel',
                    '/report',
                    'dashboard_analytics',
                ]
            } else if (formik.values.user_level === 'admin') {
                formik.values.emp_permissions = [
                    '/agency/disposal',
                    '/agency/all',
                    '/dashboard',
                    '/agency/payment',
                    '/listing/all',
                    '/listing/open',
                    '/listing/sold',
                    '/invoice/all',
                    '/invoice/payment/received',
                    '/invoice/payment/not_received',
                    '/invoice/draft',
                    '/listing/unsold',
                    '/listing/draft',
                    '/invoice/paid',
                    '/invoice/paid/completed',
                    '/invoice/paid/not_completed',
                    '/invoice/unpaid',
                    '/listing/relisted',
                    '/questions_answers',
                    '/invoice/cancel',
                    '/report',
                    'dashboard_analytics',
                ]
            } else if (formik.values.user_level === 'user') {
                formik.values.emp_permissions = [
                    '/agency/disposal',
                    '/agency/all',
                    '/dashboard',
                    '/agency/payment',
                    '/listing/all',
                    '/listing/open',
                    '/listing/sold',
                    '/invoice/all',
                    '/invoice/payment/received',
                    '/invoice/payment/not_received',
                    '/invoice/draft',
                    '/listing/unsold',
                    '/listing/draft',
                    '/invoice/paid',
                    '/invoice/paid/completed',
                    '/invoice/paid/not_completed',
                    '/invoice/unpaid',
                    '/listing/relisted',
                    '/questions_answers',
                    '/invoice/cancel',
                    '/report',
                ]
            }
        }
    }, [
        formik.values.user_level,
        props?.data?.status,
        props?.match?.params?.status,
    ])

    const permissionDetails = {
        formik: formik,
        data: [
            {
                type: 'check',
                class: 'empPermissions d-flex align-items-center flex-wrap',
                name: 'emp_permissions',
                options: permissionSelect,
            },
        ],
    }

    const validationPassword = Yup.object({
        password: Yup.string()
            .matches(
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]/,
                'Password must contain at least one lowercase letter, uppercase letter, number and special character'
            )
            .min(8, 'Minimum 8 characters')
            .required('Required'),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('password')], 'Passwords not match')
            .required('Required!'),
    })

    const formikPassword = useFormik({
        initialValues: {
            id: 0,
            change_password: true,
            password: '',
            confirm_password: '',
        },
        validationSchema: validationPassword,
        onSubmit: (values) => {
            employeeAction(values)
            setIsLoading(true)
        },
    })

    const passwordChange = [
        {
            label: 'Password',
            placeholder: 'Enter Password',
            type: 'password',
            class: 'col-sm-6 col-12',
            name: 'password',
        },
        {
            label: 'Re-Enter Password',
            placeholder: 'Re-Enter password',
            type: 'password',
            class: 'col-sm-6 col-12',
            name: 'confirm_password',
        },
    ]

    const cancelSubmit = () => {
        if (props?.match?.params?.aid) {
            handleRedirectInternal(
                history,
                `agency/edit/${props?.match?.params?.aid}`
            )
        } else {
            history.goBack()
        }
    }

    return isFullScreen ? (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? 'ADD NEW EMPLOYEE'
                    : `EDIT EMPLOYEE: ${single_employee.record.emp_firstname} ${single_employee.record.emp_lastname}`
            }
            open={data.popup}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    {formik.isSubmitting ? <LinearProgress /> : null}
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            <form
                                onSubmit={formik.handleSubmit}
                                autoComplete="nofill"
                            >
                                <h2 className="dashTitle">PERSONAL DETAILS</h2>
                                <div className="row">
                                    {mapData(personalDetailsNew)}
                                </div>

                                <h2 className="dashTitle">LOCATION DETAILS</h2>
                                <div className="row">
                                    {mapData(locationDetails)}
                                </div>

                                {/* <h2 className="dashTitle">PERMISSIONS</h2>
                            {mapData(permissionDetails)} */}
                                <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                    <SecondaryButton
                                        label="Cancel"
                                        onClick={() =>
                                            toggleFullScreenPopup(false)
                                        }
                                    />
                                    <PrimaryButton
                                        type="submit"
                                        label="Submit"
                                    />
                                </div>
                            </form>
                            {data.status === 'edit' ? (
                                <>
                                    <form
                                        onSubmit={formikPassword.handleSubmit}
                                        autoComplete="nofill"
                                    >
                                        <h2 className="dashTitle">
                                            CHANGE PASSWORD
                                        </h2>
                                        <div className="row">
                                            {mapData({
                                                formik: formikPassword,
                                                data: passwordChange,
                                            })}
                                        </div>
                                        <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                            <PrimaryButton
                                                id="employee_submit"
                                                type="submit"
                                                label="Submit"
                                            />
                                        </div>
                                    </form>
                                </>
                            ) : null}
                        </>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    ) : (
        <Layout>
            <div className="addUserModal page">
                <div className="fspBody">
                    {formik.isSubmitting ? <LinearProgress /> : null}
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            <form
                                onSubmit={formik.handleSubmit}
                                autoComplete="nofill"
                            >
                                <h2 className="dashTitle">PERSONAL DETAILS</h2>
                                <div className="row">
                                    {mapData(personalDetailsNew)}
                                </div>

                                <h2 className="dashTitle">LOCATION DETAILS</h2>
                                <div className="row">
                                    {mapData(locationDetails)}
                                </div>

                                {/* <h2 className="dashTitle">PERMISSIONS</h2>
                            {mapData(permissionDetails)} */}
                                <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                    <SecondaryButton
                                        label="Cancel"
                                        onClick={() => cancelSubmit()}
                                    />
                                    <PrimaryButton
                                        type="submit"
                                        label="Submit"
                                    />
                                </div>
                            </form>
                            {props?.match?.params?.status == 'edit' ? (
                                <>
                                    <form
                                        onSubmit={formikPassword.handleSubmit}
                                        autoComplete="nofill"
                                    >
                                        <h2 className="dashTitle">
                                            CHANGE PASSWORD
                                        </h2>
                                        <div className="row">
                                            {mapData({
                                                formik: formikPassword,
                                                data: passwordChange,
                                            })}
                                        </div>
                                        <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                            <PrimaryButton
                                                id="employee_submit"
                                                type="submit"
                                                label="Submit"
                                            />
                                        </div>
                                    </form>
                                </>
                            ) : null}
                        </>
                    )}
                </div>
            </div>
        </Layout>
    )
}

export default EmployeeManage
